import { isBefore } from 'date-fns'

export function getIsCalendarGridWeekCellPast({ now, start }) {
  return isBefore(start, new Date(now))
}

export function getIsCalendarGridWeekCellDisabled({ isPast, onClick }) {
  return !onClick || isPast
}
